'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerHost = exports.BannerHostUnwrapped = exports.registerBanner = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _SimpleBanner = require('./SimpleBanner');

var _Banners = require('./Banners.reducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var banners = {
  GenericAnnouncement: function GenericAnnouncement(props) {
    return _react2.default.createElement(_SimpleBanner.SimpleBanner, props);
  },
  GenericNotification: function GenericNotification(props) {
    return _react2.default.createElement(_SimpleBanner.SimpleBanner, props);
  },
  SuccessNotification: function SuccessNotification(props) {
    return _react2.default.createElement(_SimpleBanner.SimpleBanner, (0, _extends3.default)({}, props, { type: 'success' }));
  },
  FailureNotification: function FailureNotification(props) {
    return _react2.default.createElement(_SimpleBanner.SimpleBanner, (0, _extends3.default)({}, props, { type: 'failure' }));
  }
};

var registerBanner = exports.registerBanner = function registerBanner(componentName, component) {
  return banners[componentName] = component;
};

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    activeBanner: (0, _Banners.selectBannerToDisplay)(props.category, state)
  };
};

var mapDispatchToProps = {
  onBannerClose: _Banners.removeBanner
};

var BannerHostUnwrapped = exports.BannerHostUnwrapped = function (_Component) {
  (0, _inherits3.default)(BannerHostUnwrapped, _Component);

  function BannerHostUnwrapped() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, BannerHostUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = BannerHostUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(BannerHostUnwrapped)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleBannerClose = function () {
      var _this$props = _this.props,
          id = _this$props.activeBanner.id,
          onBannerClose = _this$props.onBannerClose;


      onBannerClose(id);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(BannerHostUnwrapped, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          category = _props.category,
          activeBanner = _props.activeBanner,
          className = _props.className;


      if (!activeBanner) {
        return null;
      }

      var bannerProps = activeBanner.props,
          bannerType = activeBanner.component;


      var BannerComponent = banners[bannerType];

      if (!BannerComponent) {
        throw new Error('Unknown banner type \'' + bannerType + '\'');
      }

      return _react2.default.createElement(
        'div',
        { className: 'banner-host banner-host--' + category + ' ' + (className || '') },
        _react2.default.createElement(BannerComponent, (0, _extends3.default)({}, bannerProps, {
          onClose: this.handleBannerClose
        }))
      );
    }
  }]);
  return BannerHostUnwrapped;
}(_react.Component);

BannerHostUnwrapped.propTypes = {
  className: _propTypes2.default.string,
  category: _propTypes2.default.oneOf(['notification', 'announcement']).isRequired,
  onBannerClose: _propTypes2.default.func.isRequired,
  activeBanner: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired
  })
};

var BannerHost = exports.BannerHost = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BannerHostUnwrapped);